<template>
    <div ref="info" class="page-warpper">
        <header-modular :url="web_emof_home"></header-modular>
        <div class="container">
            <div class="page-nav flex align-center justify-between margin-top-sm">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">您现在的位置：<span v-if="navIndex.length > 1">{{ menus.find(f => {
                        return f.value === navIndex[0]
                    }).label }} > </span>{{ title }}
                    </div>
                </div>
                <div>欢迎 <b>{{ user.morgname }}</b> ，使用会员管理系统！</div>
            </div>
            <div class="page-container flex flex-sub">
                <menu-modular :navIndex="navIndex" :upState="upState"></menu-modular>
                <div class="content-container">
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive" :key="$route.query.t" @setIndex="getIndex(arguments)"
                                     class="content" @upUserInfo="upUserInfo"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" :key="$route.query.t" @setIndex="getIndex(arguments)"
                                 class="content" @upUserInfo="upUserInfo"></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <router-link to="/version">
            <img v-if="isNew" class="version" src="../../assets/img/icon_version.png"/>
            <img v-else class="version" src="../../assets/img/icon_version.png"/>
        </router-link>
        <version-index-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                                     @watchState="watchState"></version-index-detail-dialog>
        <help-windows></help-windows>
    </div>
</template>

<script>
import HeaderModular from "./components/HeaderModular.vue";
import FooterModular from "@/components/FooterModular.vue";
import MenuModular from "./components/MenuModular.vue";
import VersionIndexDetailDialog from "@/components/VersionIndexDetailDialog";
import {organizMenus, web_emof_home} from '@/utils/const'
import config from '/package.json'
import {getInfo} from "@/api/data";
import HelpWindows from "@/components/HelpWindows";

export default {
    name: "Home",
    components: {
        HelpWindows,
        MenuModular,
        FooterModular, HeaderModular, VersionIndexDetailDialog
    },
    data() {
        return {
            menus: organizMenus,
            navIndex: [0],
            title: '',
            web_emof_home: web_emof_home,
            upState: false,
            isNew: false,
            detailDialogVisible: false,
            cur_nid: 0,
        }
    },
    created() {
        let _version = window.localStorage.getItem('version') || '1.0.0'
        this.isNew = config.version > _version
        this.getUpInfo()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {

        async getUpInfo() {
            let _data = await getInfo(this.user.type, this.user.link_id)
            if (_data.data.length === 1) {
                this.cur_nid = _data.data[0].id
                this.detailDialogVisible = true
            }
        },
        watchState() {
            this.detailDialogVisible = false;
        },

        upUserInfo() {
            this.upState = true
        },
        getIndex(data) {
            this.navIndex = data[0]
            this.title = data[1]
            this.scrollTo()
        },
        toPage(url) {
            this.$router.replace(url)
        },
        scrollTo() {
            this.$nextTick(() => {
                this.$refs.info.scrollTo(0, 0);
            });
        }
    }

}
</script>

<style lang="scss" scoped>
.page-warpper {
    height: 100vh;
    background: #ebeff5;
    overflow-y: scroll;

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;

        .page-nav {
            font-size: 16px;
            color: #0a2240;
        }

        .page-container {
            margin: 15px 0;

            .content-container {
                display: flex;
                flex-direction: column;
                width: calc(100% - 180px);
                background-color: #0a2240;
                border-radius: 10px;
                padding: 20px;
                margin-left: 10px;

                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            }
        }

    }


}
</style>
